import { GetterTree } from 'vuex';
import { CourseState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<CourseState, RootState> = {
  availableCourses: state => {
    return state.availableCourses;
  },
  isJacadCourse: state => {
    return state.isJacadCourse;
  },
};

export default getters;
